module.exports = __webpack_public_path__ + "img/临西轴承.05977acd.jpg";